import { twMerge } from "tailwind-merge";

export const Table: React.FC<
  React.PropsWithChildren<React.TableHTMLAttributes<HTMLTableElement>>
> = ({ children, className, ...props }) => (
  <table
    {...props}
    className={twMerge(
      "w-full border border-grey-light",
      "[&_th]:border [&_th]:border-grey-light [&_th]:bg-base-light-grey [&_th]:px-6 [&_th]:py-3 [&_th]:text-sm [&_th]:font-medium [&_th]:text-grey-dark",
      "[&_td]:border-y [&_td]:border-grey-light [&_td]:px-6 [&_td]:py-4 [&_td]:text-sm [&_td]:font-medium",
      className,
    )}
  >
    {children}
  </table>
);
